import { IPerformanceTableDataCampaign } from "src/types/perfomanceTable";
import { performanceData, targetData } from "./mock";
import { TableTab } from "./Tabs/models";

export const getData = (tab: TableTab) => {
  switch (tab) {
    case "Organic Keyword Performance":
      return performanceData;
    case "Current/Missing Target":
      return targetData;
    default:
      return [];
  }
};

export const getTableColumns = (activeTab: TableTab, isWhatIf: boolean) => {
  if (activeTab === "Organic Keyword Performance") {
    const base = [
      {
        title: "Organic Keyword Performance",
        dataIndex: "key",
        key: "key",
        width: 300,
        fixed: "left" as const,
        render: (_: any, record: IPerformanceTableDataCampaign) => record.key,
      },
    ];

    const rest = [
      {
        title: "Search Volume",
        dataIndex: "search_query_volume",
        key: "search_query_volume",
        render: (v?: number) => (v != null ? v.toLocaleString("en-US") : "–"),
      },
      {
        title: "Organic Rank AVG",
        dataIndex: "organic_rank_avg",
        key: "organic_rank_avg",
        render: (v?: number) => v ?? "–",
      },
      {
        title: "Organic Rank AVG Delta",
        dataIndex: "organic_rank_avg_delta",
        key: "organic_rank_avg_delta",
        render: (v?: number) => v ?? "–",
      },
      {
        title: "Relevancy Score",
        dataIndex: "relevancy_score",
        key: "relevancy_score",
        render: (v?: number) => v ?? "–",
      },
      {
        title: "Impressions",
        dataIndex: "impressions",
        key: "impressions",
        render: (v?: number) => (v != null ? v.toLocaleString("en-US") : "–"),
      },
      {
        title: "TOS Impressions share",
        dataIndex: "tos_impressions_share",
        key: "tos_impressions_share",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "Clicks",
        dataIndex: "clicks",
        key: "clicks",
        render: (v?: number) => (v != null ? v.toLocaleString("en-US") : "–"),
      },
      {
        title: "CTR",
        dataIndex: "ctr",
        key: "ctr",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "Ad Spend",
        dataIndex: "spend",
        key: "spend",
        render: (v?: number) =>
          v != null ? `$${Math.round(v).toLocaleString("en-US")}` : "–",
      },
      {
        title: "CPC",
        dataIndex: "cpc",
        key: "cpc",
        render: (v?: number) => (v != null ? Math.round(v) : "–"),
      },
      {
        title: "Units Sold",
        dataIndex: "units_sold",
        key: "units_sold",
        render: (v?: number) => (v != null ? v.toLocaleString("en-US") : "–"),
      },
      {
        title: "CVR",
        dataIndex: "cvr",
        key: "cvr",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "Sales",
        dataIndex: "sales",
        key: "sales",
        render: (v?: number) =>
          v != null ? `$${Math.round(v).toLocaleString("en-US")}` : "–",
      },
      {
        title: "Sales Share",
        dataIndex: "sales_share",
        key: "sales_share",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "ACOS",
        dataIndex: "acos",
        key: "acos",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "TACOS",
        dataIndex: "tacos",
        key: "tacos",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "SVR",
        dataIndex: "svr",
        key: "svr",
        render: (v?: number) => (v != null ? `${(v * 100).toFixed(2)}%` : "–"),
      },
      {
        title: "Competition Index",
        dataIndex: "competition_index",
        key: "competition_index",
        render: (v?: number) => v ?? "–",
      },
    ];

    return [...base, ...rest];
  }

  return generateColumns(activeTab, isWhatIf);
};
